// @core/api/endpoints/fiscalization/get_fiscal_policy.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  FiscalPolicyResponse,
} from '../../../types/fiscalization';

const BASE_PATH = '/fiscalization';

/**
 * Get fiscal policy
 * Returns a fiscal policy by ID.
 */
export async function GetFiscalPolicy(
  policy_id: string,
  options?: RequestOptions
): Promise<FiscalPolicyResponse> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/fiscal-policies/:policy_id`;
  requestPath = requestPath.replace(':policy_id', encodeURIComponent(policy_id));
  const requestOptions = options;
  return client.get<FiscalPolicyResponse>(requestPath, { ...requestOptions });
}
